module.exports = __webpack_public_path__ + "static/media/stats-mobile1.ee79b01f.png";